// Campaigns API Client
import { apiClient } from './apiClient';
import type { Campaign } from '../types/campaign';

export const campaignsApi = {
  // List all campaigns
  async list(params?: {
    platform?: string;
    status?: string;
    search?: string;
  }): Promise<Campaign[]> {
    const response = await apiClient.get('campaigns', { params });
    return response.data.campaigns || response.data;
  },

  // Get single campaign
  async get(id: string): Promise<Campaign> {
    const response = await apiClient.get(`campaigns/${id}`);
    return response.data;
  },

  // Create campaign
  async create(data: Partial<Campaign>): Promise<Campaign> {
    const response = await apiClient.post('campaigns', data);
    return response.data;
  },

  // Update campaign
  async update(id: string, data: Partial<Campaign>): Promise<Campaign> {
    const response = await apiClient.put(`campaigns/${id}`, data);
    return response.data;
  },

  // Delete campaign
  async delete(id: string): Promise<void> {
    await apiClient.delete(`campaigns/${id}`);
  },

  // Pause campaign
  async pause(id: string): Promise<Campaign> {
    const response = await apiClient.post(`campaigns/${id}/pause`);
    return response.data;
  },

  // Resume campaign
  async resume(id: string): Promise<Campaign> {
    const response = await apiClient.post(`campaigns/${id}/resume`);
    return response.data;
  },
};
